const removeSpaces = (value = ''): string => {
  return value.replace(/ /g, '');
};

export default removeSpaces;
